import React from "react";
import {MobileOutlined} from "@ant-design/icons";
import {globalUrlPrefix} from "../../utils/const";
import {Button, Col, Layout, Row} from "antd";
import {Link} from "react-router-dom";
import {ArrowBackOutlined} from "@mui/icons-material";

const { Content } = Layout;

function C240Settings(props) {

    let deviceId = props.match.params.id;

    return (
        <Content className={"c240-settings-container"} style={{ padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Row>
                <Row style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '50px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    padding: '30px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    zIndex: '1000',
                    marginBottom: "100px",
                    position: "fixed",
                    top: 0,
                    right: 0,
                    left: 0
                }} className={"settings-header"}>
                    <Link to={"/" + globalUrlPrefix + "/c240_control_panel/" + deviceId}>
                        <ArrowBackOutlined style={{fontSize: "32px"}} />
                    </Link>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                        <h1 style={{ fontSize: "38px", textAlign: "center", margin: 0 }}>Scanner Settings</h1>
                    </div>
                </Row>

                <Row style={{marginTop: "100px"}}>
                    <Col>
                        <Link to={"/" + globalUrlPrefix + "/c240_stage_cleanup/" + props.match.params.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Row>
                                <MobileOutlined style={{ fontSize: "48px" }} />
                            </Row>
                            <Row>
                                <div style={{ textAlign: 'center' }}>Stage Maintenance</div>
                            </Row>
                        </Link>
                    </Col>
                </Row>
            </Row>
        </Content>
    );
}

export default C240Settings;